import { createLaminateProductHook } from '../laminate-api/createLaminateProductHook';
import { useFetchEndSplashQuery } from './endSplashService';

import { EndSplashProduct } from '~/core/models';

const _useEndSplash = createLaminateProductHook<EndSplashProduct>(
  useFetchEndSplashQuery
);

export const useEndSplash = () => {
  const { data, isFetching, ...rest } = _useEndSplash();

  return {
    endSplashes: data,
    isFetchingEndSplashes: isFetching,
    ...rest,
  };
};

export type UseEndSplashReturn = ReturnType<typeof useEndSplash>;
